import React from "react"

import Edges from "../../Edges"

interface ISpecificationItem {
  label: string
  value: string
  bg: string
}

interface ISpecificationList {
  specificationList: Array<any>
}

interface IDetailedSpecifications {
  backgroundColor: string
  heading: string
  groups: Array<any>
}

const SpecificationItem = ({ label, value, bg = "" }: ISpecificationItem) => {
  return (
    <div
      className={`grid grid-cols-3 rounded-lg py-3 px-3 xl:grid-cols-5 xl:px-6 ${bg}`}
    >
      <div className="col-span-1 text-body2 font-black text-darkGrey">
        {label}
      </div>
      <div className="col-span-2 ml-[20px] flex items-center text-body2 text-darkGrey xl:col-span-4">
        {value}
      </div>
    </div>
  )
}

const SpecificationList = ({ specificationList }: ISpecificationList) => {
  return (
    specificationList && (
      <div>
        {specificationList?.map((specification, idx) => {
          return (
            <SpecificationItem
              key={idx}
              label={specification.label}
              value={specification.value}
              bg={idx % 2 !== 0 ? "bg-white" : "bg-lightGrey"}
            />
          )
        })}
      </div>
    )
  )
}

const DetailedSpecifications = ({
  backgroundColor = "",
  groups,
  heading = "",
}: IDetailedSpecifications) => {
  return (
    <Edges size="md">
      <div
        style={{
          backgroundColor: backgroundColor ? backgroundColor : "#ffffff",
        }}
        className={` flex flex-col px-[15px] xl:px-0`}
      >
        {heading && (
          <h2 className="mb-[36px] text-center text-darkBlue">{heading}</h2>
        )}

        <div className="">
          <div
            className={
              groups?.length === 1
                ? "grid grid-cols-1 md:grid-cols-1 md:gap-6"
                : "grid grid-cols-1 md:grid-cols-2 md:gap-6"
            }
          >
            {groups?.map?.(({ items }, index) => {
              return <SpecificationList key={index} specificationList={items} />
            })}
          </div>
        </div>
      </div>
      <div className="mb-[59px] mt-[45px] border-b-[2px] border-lightGrey"></div>
    </Edges>
  )
}

export default DetailedSpecifications
